import KeyboardDismissView from "@app/hoc/KeyboardDismissView";
import ScreenWrapper from "@app/hoc/ScreenWrapper";
import { PrivateStackParamList } from "@app/navigationApp/types";
import CommonHeader from "@app/sharedComponents/Header/Header";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import { Theme, ThemedText, ThemedView } from "@app/theme";
import { addCommasToNumber, getDesiredValue, getTotalLimit, getUpdateAvailableCAS, isFirstSetCreditLimitVisit, roundDownToNearestHundred, trackEvent } from "@app/utils";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Platform, ScrollView, TouchableOpacity } from "react-native";
import { getApplicationId } from "../FetchPortfolio/utils";
import { endpoints } from "@app/api/apis";
import axios from "axios";
import { AvailableCASMap, setAuthCAS, setAvailableCAS } from "@app/store/slices/applicationSlice";
import { useEffect, useState } from "react";
import MutualFundList from "../UnlockLimitLanding/components/MutualFundsList/MutualFundsList";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import Button from '@sharedComponents/Button/Button';
import { useIsFocused } from "@react-navigation/native";
import RangeSlider from "@app/sharedComponents/Slider/Slider";
import { formatIndianCurrency } from "@app/utils/utility";
import EditIcon from "@app/assets/svg/EditIcon";
import { useTheme } from "@shopify/restyle";
import EditAmountModal from "./Components/EditAmountModal";
import { useIsEnhanceLimit } from "@app/hooks/useIsEnhanceLimit";
import ROUTE from "@app/navigationApp/routes";
import handleApiErr from "@app/helper/handleApiErr";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import useIsMobileBrowser from "@app/hooks/useIsMobileBrowser";
import { updatePartnerParams } from "@app/store/slices/platformSlice";
import { filterByRepository } from "../UnlockLimitLanding/utils";

type SetCreditLimitProps = NativeStackScreenProps<PrivateStackParamList, 'SET_CREDIT_LIMIT'> & {

}

const SetCreditLimit = ({
    navigation,
    route
}: SetCreditLimitProps) => {

    const { minimumEligibleLimit, authCAS, availableCAS } = useAppSelector(state => state.application);
    const { userDetails } = useAppSelector((state) => state.auth);
    const [sliderValue, setSliderValue] = useState(authCAS?.availableCreditAmount || 0);
    const [portValue, setPortValue] = useState(0);
    const dispatch = useAppDispatch();
    const isFocused = useIsFocused();
    const [btnLoading, setBtnLoading] = useState(false);
    const { colors } = useTheme<Theme>()
    const [showEditAmountModal, setShowEditAmountModal] = useState(false);
    const { isFromEnhanceLimit } = useIsEnhanceLimit();
    const isMobileBrowser = useIsMobileBrowser();
    const [availableCASData, setAvailableCASData] = useState<AvailableCASMap>({});

    let rta = undefined


    useEffect(() => {
        if (availableCAS) {
            setAvailableCASData(
                rta ? availableCAS && filterByRepository(availableCAS, rta === 'MFCENTRAL' ? 'ALL' : rta) : availableCAS
            );
        } else {
            setAvailableCASData(
                rta ? authCAS?.availableCAS && filterByRepository(authCAS?.availableCAS, rta === 'MFCENTRAL' ? 'ALL' : rta) : authCAS?.availableCAS
            );
        }
    }, [authCAS, availableCAS, rta]);

    const sliderValueSynced = addCommasToNumber(
        roundDownToNearestHundred(
            getTotalLimit(
                Object.values(availableCASData),
                authCAS?.isinNAVMap,
                authCAS?.isinLTVMap
            )
        )
    )
            


    const initialiseAvailableCAS = (availableCAS: any[]) => {
        const updatedAvailableCAS: AvailableCASMap = {}
        const _availableCAS = availableCAS;
        if (_availableCAS) {
            _availableCAS.forEach((item) => {
                updatedAvailableCAS[item.isinNo + '-' + item.folioNo] = {
                    ...item,
                    pledgedUnits: item.totalAvailableUnits,
                    isPledged: true
                };
            });
        }
        dispatch(setAvailableCAS(updatedAvailableCAS));
        return updatedAvailableCAS;
    }

    const outOfValue = availableCAS && authCAS && addCommasToNumber(
        roundDownToNearestHundred(
            getTotalLimit(
                Object.values(availableCAS),
                authCAS.isinNAVMap,
                authCAS.isinLTVMap
            )
        )
    )

    const ctaDisabled = parseInt(outOfValue?.replace(/,/g, '') ?? '0') < (minimumEligibleLimit?.amount ?? 10000)


    const savePledgeLimit = async () => {
        let pledgeDataToSave = availableCAS && Object.values(availableCAS).filter((item) => item.pledgedUnits > 0);
        pledgeDataToSave = pledgeDataToSave && pledgeDataToSave.map((item) => ({
            ...item,
            is_pledged: item.pledgedUnits > 0 ? true : false
        }));
        setBtnLoading(true);
        const applicationId = await getApplicationId(userDetails?.linkedApplications[0]?.applicationId);
        const url = endpoints.pledgeSave;
        await axios.post(url, {
            applicationId: applicationId,
            portfolioItemList: pledgeDataToSave
        }).then((response) => {
            if(isFromEnhanceLimit) {
                navigation.navigate(ROUTE.LOAN_OFFER_ENHANCE_LIMIT , {source: 'SET_CREDIT_LIMIT'});
            } else {
                navigation.navigate(ROUTE.PLEDGE_CONFIRMATION);
            }
            setBtnLoading(false);
        }).catch((error) => {
            if (error?.data?.statusCode && handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    errorHeading: error?.data?.header,
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
            setBtnLoading(false);
        });
    }

    const isSelectedForPledge = isFirstSetCreditLimitVisit(Object.values(availableCAS ?? {})) && Platform.OS !== 'web';

    //to handle when the user come back from the portfolio screen
    useEffect(() => {
        if (
            (route.params?.fromEditSelection || Platform.OS !== 'web') && 
            availableCAS && 
            authCAS?.isinNAVMap
        ) {
            const portValue = getDesiredValue(
                Object.values(availableCAS),
                authCAS?.isinNAVMap
            );
            setPortValue(portValue);
            const sliderValue = addCommasToNumber(
                roundDownToNearestHundred(
                    getTotalLimit(
                        Object.values(availableCAS),
                        authCAS.isinNAVMap,
                        authCAS.isinLTVMap
                    )
                )
            )
            if (Platform.OS === 'web') {
                setSliderValue(parseInt(sliderValue?.replace(/[^0-9]/g, "")));
            } else {
                setSliderValue(parseInt(sliderValueSynced?.replace(/[^0-9]/g, "")));
            }
        }
    }, [isFocused , sliderValueSynced]);

    useEffect(() => {
        if (availableCAS && authCAS?.isinNAVMap) {
            const portValue = getDesiredValue(
                Object.values(availableCAS),
                authCAS?.isinNAVMap
            );
            setPortValue(portValue);
        }
    }, [availableCAS]);

    useEffect(() => {
        authCAS && initialiseAvailableCAS(authCAS?.availableCAS);
    }, [authCAS]);

    useEffect(() => {
        // user reaches here only after min limit is reached hence marking showCall as true in case of refresh or anything
        dispatch(updatePartnerParams({showCall:true}))
    }, [])

    const renderDetails = () => {
        return (
            <ThemedView style={{ flex: 1, borderTopLeftRadius: 16, borderTopRightRadius: 16, backgroundColor: 'white', position: 'relative', bottom: 16 }}>
                <ThemedView style={{ paddingHorizontal: 16 }}>
                    <ThemedView style={{ marginBottom: 12 }} />
                    <ThemedView style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                    </ThemedView>
                    <ThemedView style={{ marginBottom: 18 }} />
                    <ThemedView style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <ThemedText variant="h5s" color="text-primary" textAlign='center'>Selected mutual funds
                        </ThemedText>
                        <TouchableOpacity onPress={() => {
                            !btnLoading &&
                            navigation.navigate('PORTFOLIO');
                            trackEvent('SET_CREDIT_LIMIT_EDITMF_EDITFUNDAMOUNT_CLICKED',{
                                amount: sliderValue
                            })
                        }}>
                            <ThemedText variant="b3s" color="text-action-primary" textAlign='center'>Edit selection</ThemedText>
                        </TouchableOpacity>
                    </ThemedView>
                    <ThemedView style={{ marginBottom: 12 }} />
                    <ThemedText variant="b3r" color="text-secondary" >₹{addCommasToNumber(portValue || 0)} out of ₹{addCommasToNumber(authCAS?.totalPortfolioAmount || 0)} are selected for pledging.</ThemedText>
                    <MutualFundList />
                </ThemedView>
            </ThemedView>
        )
    }

    const computeAuthCasOnValueChange = (value: number) => {
        let updateAvailableCASMap: AvailableCASMap = { ...availableCAS };
        // console.log("DSR updatedAvailableCAS: ", updatedAvailableCAS); 
        if (value > 0) {
            if (authCAS && availableCAS) {
                let _authCas = { ...authCAS }; // Create a proper copy
                _authCas.availableCAS = _authCas.availableCAS.map(item => ({
                    ...item,
                    pledgedUnits: item.totalAvailableUnits
                }));
                const updatedAvailableCAS = getUpdateAvailableCAS(
                    value,
                    _authCas.availableCAS,
                    _authCas.isinNAVMap,
                    _authCas.isinLTVMap
                );
                updatedAvailableCAS.forEach((item) => {
                    const key = `${item.isinNo}-${item.folioNo}`;
                    updateAvailableCASMap[key] = item;
                });
            }
        } else {
            if (authCAS && availableCAS) {
                authCAS.availableCAS.map((item) => {
                    const key = `${item.isinNo}-${item.folioNo}`;
                    item.pledgedUnits = item.totalAvailableUnits;
                    updateAvailableCASMap[key] = item;
                });
            }
        }
        dispatch(setAvailableCAS(updateAvailableCASMap))
    }

    const sliderComplete = (value: number) => {
        computeAuthCasOnValueChange(value);
    }

    return (<>
        <ScreenWrapper screenName={route.name}>
                <ThemedView flex={1} style={{ backgroundColor: 'white' }}>
                    <CommonHeader
                        label='Set credit limit'
                        navigation={navigation}
                        pageName={route.name}
                    />
                    <ScrollView
                        style={{ flex: 1 }}
                        showsVerticalScrollIndicator={false}
                        keyboardShouldPersistTaps='handled'
                    >
                        <ThemedView style={{ flex: 1 }}>
                            <ThemedView style={{ paddingHorizontal: 16 }} backgroundColor="bg-surface-page">
                                <ThemedView style={{ marginBottom: 32 }} />
                                <ThemedText variant="h5s" color="text-primary" textAlign='center'>
                                    Select the amount
                                </ThemedText>
                                <ThemedView style={{ marginBottom: 18 }} />
                                {
                                    authCAS && minimumEligibleLimit &&
                                    <ThemedView>
                                        <ThemedView mb="5xl" flexDirection='row' justifyContent='center' alignItems='center'>
                                            <ThemedText variant="h1b" color="text-primary" textAlign='center'>
                                            <ThemedText fontFamily='Inter' variant="h1b" color="text-primary" textAlign='center'>₹</ThemedText>
                                                {formatIndianCurrency(sliderValue.toFixed(0))} </ThemedText>
                                            <TouchableOpacity
                                             hitSlop={{left : 10 , right :10 , bottom : 10 , top :10}}
                                            onPress={() => {
                                                // setOpenUpdateNumber(true)
                                                setShowEditAmountModal(true)
                                                trackEvent('SET_CREDIT_LIMIT_EDIT_AMOUNT_CLICKED')
                                            }}>
                                                <EditIcon size={20} color={colors['bg-fill-emphasis-primary-2']} />
                                            </TouchableOpacity>
                                        </ThemedView>
                                        <RangeSlider
                                            min={minimumEligibleLimit?.amount}
                                            max={authCAS?.availableCreditAmount}
                                            value={sliderValue}
                                            onChange={(value) => {
                                                if(btnLoading) return;
                                                setSliderValue(value)
                                            }}
                                            onComplete={(value) => {
                                                if(btnLoading) return;
                                                sliderComplete(value)
                                            }}
                                        />
                                    </ThemedView>
                                }
                                <ThemedView style={{ marginBottom: 12 }} />
                                <ThemedView style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <ThemedText variant="b4r" color="text-secondary" textAlign='center'>
                                        Min ₹{addCommasToNumber(minimumEligibleLimit?.amount || 0)}
                                    </ThemedText>
                                    <ThemedText variant="b4r" color="text-secondary" textAlign='center'>
                                        Max ₹{addCommasToNumber(authCAS?.availableCreditAmount || 0)}
                                    </ThemedText>
                                </ThemedView>
                                <ThemedView style={{ marginBottom: 24 }} />
                                <ThemedView style={{ marginBottom: 24 }} />
                            </ThemedView>
                            {renderDetails()}
                        </ThemedView>
                    </ScrollView>
                    {(!showEditAmountModal || Platform.OS !== 'web') && (
                        <ThemedView
                            backgroundColor='bg-surface-primary'
                            borderTopWidth={1}
                            borderTopColor='border-primary'
                        >
                            <ThemedView m="lg">
                                <Button
                                    eventName={route.name + '_CONFIRM_LIMIT_AND_PROCEED_BUTTON_CLICKED'}
                                    additionalProperties={{
                                        amount: sliderValue
                                    }}
                                    label={'Confirm limit and proceed'}
                                    handlePress={() => {
                                        !btnLoading && savePledgeLimit();
                                    }}
                                    type={'SOLID'}
                                    size='MD'
                                    bg='bg-primary'
                                    textColor='text-primary'
                                    disabled={ctaDisabled || btnLoading}
                                    buttonLoader={btnLoading}
                                />
                            </ThemedView>
                        </ThemedView>
                    )}
                </ThemedView>
            <BottomSheetContainer
                isVisible={showEditAmountModal}
                closeOnBackdropPress={false}
                close={() => setShowEditAmountModal(false)}
                onClose={() => setShowEditAmountModal(false)}
                dragComponent={<ThemedView style={{ height: 12 }} />}
                containerStyle={{ borderTopRightRadius: 16, borderTopLeftRadius: 16 ,
                    maxHeight: '80%',
                    minHeight: !isMobileBrowser ? undefined : 250, 
                }}
                showCloseIcon={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}

            >
                <EditAmountModal initialAmount={sliderValue}
                    onChange={(amount) => {
                            setShowEditAmountModal(false)
                            setTimeout(() => {
                                setSliderValue(amount)
                                computeAuthCasOnValueChange(amount)
                            }, 0)
                    }}
                    minAmount={minimumEligibleLimit?.amount || 0}
                    maxAmount={authCAS?.availableCreditAmount || 0}
                />
            </BottomSheetContainer>
        </ScreenWrapper>
    </>)
}

export default SetCreditLimit;